module.exports = __webpack_public_path__ + "static/media/logo.bc2a101e.png";